import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { map, shareReplay, switchMap, take, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { RegStatusCode } from '../../enums/registration-statuscode.enum';
import { RegistrationsListResponseModel, RegistrationStatusResponseModel } from './registration-status-response-model';
import { RegistrationResponseByRegistrationIdModel } from '../../../registrations-data/models/response/registrations-response.model';
import { ViewType } from '../../../registrations-data/models/response/view-type-response.model';
import { CodeDescriptionModel } from 'src/app/models/code-description.model';
import { RegistrationModel } from 'src/app/registrations-data/models/data/registration.model';
import { NewRegistrationDataCollectionService } from './newRegistration-data-collection.service';
import { ApartmentInfoReportsRaiComponent
} from 'src/app/building-dashboard/apartment-info-reports-rai/apartment-info-reports-rai.component';
import { ApartmentInfoModel } from 'src/app/registrations-data/models/data/apartment-info.model';

@Injectable({
  providedIn: 'root',
})
export class NewRegistrationService {

  baseurl = environment.baseUrlRegistration;
  baseUrlParty = environment.baseUrlParties;
  baseUrlBuildings = environment.baseUrlBuildings;
  setStatusAccepted: boolean;
  regId: string;
  buildingId: string;
  url: string = null;
  classicAptCount = 0;
  activatedRoute: any;
  formsState = {
    building: false,
    services: false,
    apartments: false,
    review: false,
  };
  currentIncident: RegistrationStatusResponseModel = null;
  modifiedmenus: any;
  isNewApartment = false;

  public isSubmittableSubject: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  public readonly isSubmittable$: Observable<boolean> = this.isSubmittableSubject.asObservable().pipe(shareReplay(1));

  private documentDownloadSubject = new Subject<string>();
  private buildingGUID: string;
  private BuildingSelectedSubject = new BehaviorSubject<string>(''); /// reload the page  - id = null, click ->building
  buildingregistrations$ = this.BuildingSelectedSubject.pipe(
    take(1),
    switchMap((id) =>
      this.httpClient.get<RegistrationsListResponseModel>(
        this.baseUrlBuildings + '/' + id + '/registrations/'
      )
    )
  );

  private viewSubject = new BehaviorSubject<string>('Classic');
  view$ = this.viewSubject.asObservable();
  docDownload$ = this.documentDownloadSubject.pipe(
    switchMap((docId) =>
      this.httpClient
        .get(
          this.baseurl +
          '/' +
          this.registrationGUID +
          '/documents/' +
          docId,
          { responseType: 'blob' }
        )
        .pipe(
          map((res) => {
            this.openDoc(res);
            return res;
          })
        )
    )
  );

  // because we don't have the feature of a side by side comparison right now there is no need to have two different primary key attributes
  private registrationGUID: string;
  private selectedRegGUIDSubject = new BehaviorSubject<string>(this.url);
  selectedRegistrationGUID$: Observable<string> = this.selectedRegGUIDSubject.asObservable();
  private currentStatus: string;
  private registration: RegistrationModel = null;
  private selectedRegistrationSubject = new BehaviorSubject<RegistrationModel>(
    this.registration
  );
  selectedRegistrationModel$ = this.selectedRegistrationSubject.asObservable();

  // private selectedRegStatus: RegistrationStatusResponseModel;
  // private approvedRegSubject = new BehaviorSubject<
  //   RegistrationStatusResponseModel
  // >(this.selectedRegStatus);
  // approvedRegModel$ = this.approvedRegSubject.asObservable();

  private freshFromServerRegistrationCache$;

  // documents$ = this.freshFromServerRegistration$.pipe(
  //   switchMap((reg) =>
  //     this.httpClient
  //       .get(
  //         this.baseurl +
  //         '/' +
  //         this.registrationGUID +
  //         '/documents'
  //       )
  //       .pipe(
  //         map((docs) => {
  //           console.log('got these docs ...', docs);
  //           return docs;
  //         })
  //       )
  //   )
  // );
  approvedBlngId: any;
  approvedId: any;
  diffPayLoadSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  diffPayLoad$ = this.diffPayLoadSubject.asObservable();
  approvedRegiSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  approvedRegistration$ = this.approvedRegiSubject.asObservable();
  dataItem: any;
  showDiffOption = false;
  constructor(
    private httpClient: HttpClient,
    private datacollectionSvc: NewRegistrationDataCollectionService,
  ) { }

  setIsNewApartment(flag: boolean) {
    this.isNewApartment = flag;
  }


  getIsNewApartment() {
    return this.isNewApartment;
  }

  // tslint:disable-next-line: member-ordering
  menus = [
    {
      id: 0,
      icon: 'fa fa-building',
      name: 'Building Info',
      url: 'building',
      selected: true,
      color: '#b980e3',
      isValid: false,
      visible: true
    },
    {
      id: 1,
      icon: 'fa fa-university',
      name: 'Building Services',
      url: 'services',
      selected: false,
      color: '#b980e3',
      isValid: false,
      visible: true
    },
    {
      id: 2,
      icon: 'fa fa-building-o',
      name: 'Apartments ',
      url: 'apartments',
      selected: false,
      color: '#b980e3',
      isValid: false,
      visible: true
    },
    {
      id: 3,
      icon: 'fa fa-th-list',
      name: 'Review',
      url: 'review',
      selected: false,
      color: '#b980e3',
      isValid: false,
      visible: true
    },
    {
      id: 4,
      icon: 'fa fa-pencil-square-o',
      name: 'Show Difference',
      url: 'review',
      selected: false,
      color: '#b980e3',
      isValid: false,
      visible: false
    },
    {
      id: 5,
      icon: 'fa fa-file-pdf-o',
      name: 'Documents',
      url: 'documents',
      selected: false,
      color: '#b980e3',
      isValid: false,
      visible: false
    },
    {
      id: 6,
      icon: 'fa fa-comments',
      name: 'Messages',
      url: 'comments',
      selected: false,
      color: '#b980e3',
      isValid: false,
      visible: false
    }
  ];

  getRegByStatus(model: RegistrationStatusResponseModel = null, guid: string = null) {
    if (model) {
      this.url = this.baseurl + '/' + model.registrationId;
    }
    if (guid !== null) {
      this.url = this.baseurl + '/' + guid;
    }
    this.currentStatus = (model && model.status.code) || RegStatusCode.INPROGRESS;
    // if (model && model.status.code === RegStatusCode.APPROVED) {
    //   this.url =
    //     this.baseUrlRegistrations +
    //     '/' +
    //     model.buildingId +
    //     '/Registrations/' +
    //     model.id;
    // }
    // if (model && model.status.code === RegStatusCode.INPROGRESS) {
    //   this.url = this.baseUrlJSON + '/jsonpayloads/' + model.id;
    // }
    // if (!model && guid) {
    //   this.url = this.baseUrlJSON + '/jsonpayloads/' + guid;
    // }
    this.selectedRegGUIDSubject.next(this.url);
    return this.httpClient.get(this.url).pipe(shareReplay(1));
  }

  getRegistrations(registrationId: string = null): Observable<RegistrationResponseByRegistrationIdModel> {
    if (registrationId) {
      return this.httpClient.get<RegistrationResponseByRegistrationIdModel>(this.baseurl + '/' + registrationId).pipe(shareReplay(1));
    }
    return null;
  }

  getBuildingRegistrations(buildingId: string): Observable<RegistrationsListResponseModel> {
    return this.httpClient.get<RegistrationsListResponseModel>(
      this.baseUrlBuildings + '/' + buildingId + '/registrations/').pipe(shareReplay(1));
  }

  // get freshFromServerRegistration$() {
  //   if (!this.freshFromServerRegistrationCache$) {
  //     this.freshFromServerRegistrationCache$ = this.selectedRegistrationGUID$.pipe(
  //       switchMap((guid) =>
  //         this.httpClient
  //           .get(this.baseurl + '/' + this.registrationGUID)
  //           .pipe(
  //             tap(
  //               // Log the result or error
  //               (data) => this.logData(data),
  //               (error) => this.logError(error)
  //             )
  //           )
  //           .pipe(
  //             tap((x) => console.log('Going to map a incident for reg', x)),
  //             map((value: any) => {
  //               let reg = null;
  //               if (this.currentStatus === RegStatusCode.INPROGRESS) {
  //                 reg = this.handleInProgressReg(value);
  //               } else {
  //                 reg = this.handleOtherReg(value);
  //               }
  //               this.datacollectionSvc.setRegistration(reg);
  //               if (value.registrationId) {
  //                 this.datacollectionSvc.setSelectedTransactionGUID(value.registrationId);
  //               }
  //               return reg;
  //             })
  //           )
  //       ),
  //       shareReplay(1)
  //     );
  //   }
  //   return this.freshFromServerRegistrationCache$;
  // }

  // get freshFromServerRegistration$() {
  //   if (!this.freshFromServerRegistrationCache$) {
  //     this.freshFromServerRegistrationCache$ =
  //         this.httpClient
  //           .get(this.baseurl + '/' + this.registrationGUID)
  //           .pipe(
  //             tap(
  //               // Log the result or error
  //               (data) => this.logData(data),
  //               (error) => this.logError(error)
  //             ),
  //             map((value: any) => {
  //               let reg = null;
  //               if (value.status.code === RegStatusCode.REQUESTED_FOR_MOREINFO) {
  //                 reg = this.handleInProgressReg(value);
  //               } else {
  //                 reg = this.handleOtherReg(value);
  //               }
  //               this.datacollectionSvc.setRegistration(reg);
  //               if (value.registrationId) {
  //                 this.datacollectionSvc.setSelectedTransactionGUID(value.registrationId);
  //               }
  //             }),
  //       shareReplay(1));
  //   }
  //   return this.freshFromServerRegistrationCache$;
  // }

  getDocuments(registrationsId: string) {
    return this.httpClient
        .get(
          this.baseurl +
          '/' +
          registrationsId +
          '/documents'
        )
        .pipe(
          map((docs) => {
            console.log('got these docs ...', docs);
            return docs;
          })
        );
  }

  getPreviousDocuments(registrationsId: string) {
    return this.httpClient.get(this.baseurl + '/' + registrationsId + '/documents?category=notices').pipe(
          map((docs) => {
            console.log('got these docs ...', docs);
            return docs;
          })
        );
  }

  resetServerRegData() {
    this.freshFromServerRegistrationCache$ = null;
  }

  handleOtherReg(value: any) {
    if (value.data) {
      const jsonPayLoad = JSON.parse(value.data);
      // updated code according to new models
      let reg: RegistrationModel = new RegistrationModel();
      reg = jsonPayLoad;
      return reg;
    }
    return null;
  }

  handleInProgressReg(value: any) {
    const jsonPayLoad = JSON.parse(value.data);
    let reg: RegistrationModel = new RegistrationModel();
    reg = jsonPayLoad;
    reg.registrationStatus = new CodeDescriptionModel({ code: RegStatusCode.INPROGRESS, description: 'In Progress',
     shortName: 'In Progress' });
    return reg;
  }

  /*  logError(error: any): void {
     console.log('Logg svc error', error);
   }
   logData(data: Object): void {
     console.log('Lot o data loggin', data);

   }
   activateMenu(activerouteIndex: number) {
     this.menus.forEach((menu) => {
       menu.selected = false;
     });
     this.menus[activerouteIndex].selected = true;
     this.menus[activerouteIndex].selected = true;
   } */
  logError(error: any): void {
    console.log('Logg svc error', error);
  }
  // tslint:disable-next-line: ban-types
  logData(data: Object): void {
    console.log('Lot o data loggin', data);
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  activateMenu(activerouteIndex: number) {
    this.menus.forEach((menu) => {
      menu.selected = false;
    });
    this.menus[activerouteIndex].selected = true;
  }

  setMenuDetails(includeShowDiff = false, isAccepted = false, showComments = false) {
    this.menus.find(menu => menu.name === 'Show Difference').visible = includeShowDiff;
    this.menus.find(menu => menu.name === 'Documents').visible = isAccepted;
    this.menus.find(menu => menu.name === 'Messages').visible = showComments;
    this.showDiffOption = !!includeShowDiff;
  }


  selectBuilding(id: string): void {
    console.log('selected building GUID:' + id);
    this.buildingGUID = id;
    if (id) {
      this.BuildingSelectedSubject.next(id);
    }
  }

  getBuilding() {
    return this.registration.building;
  }

  updateBuilding(reg: any): void {
    // console.log('setting data in reg', reg);
    if (this.registration) {
      this.registration.building = reg.building;
    } else {
      this.registration = reg;
    }
  }

  setCurrentIncident(incident) {
    this.currentIncident = incident;
  }
  getCurrentIncident() {
    return this.currentIncident;
  }

  setSelectedGUID(guid: string) {
    if (guid) {
      this.selectedRegGUIDSubject.next(guid);
    }
    this.registrationGUID = guid;
  }

  setSelectedRegistrationForm(reg: RegistrationModel) {
    // console.log('Setting selected registration model via svc');
    if (reg) {
      this.selectedRegistrationSubject.next(reg);
    }
    this.registration = reg;
  }

  getAllRegistrations() {
    return this.httpClient.get(
      this.baseUrlBuildings + '/Registrations'
    ).pipe(shareReplay(1));
  }

  openDoc(res) {
    const blob = new Blob([res], { type: res.type });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  }

  downloadDocument(IncidentActivityDocumentId: string, registrationId: string = null) {
    this.documentDownloadSubject.next(IncidentActivityDocumentId);
    return this.httpClient
        .get(
          this.baseurl +
          '/' +
          registrationId +
          '/documents/' +
          IncidentActivityDocumentId,
          { responseType: 'blob' }
        )
        .pipe(
          map((res) => {
            this.openDoc(res);
            return res;
          })
        )
  }

  // from deborah kurata
  private handleError(err: any) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage: string;
    if (err !== undefined) {
      if (err !== undefined || err.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        errorMessage = `An error occurred: ${err.error.message}`;
      } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        errorMessage = `no info on error`;
      }
    } else {
      console.error(err);
    }
    return throwError(errorMessage);
  }
  setTab(menudata) {
    console.log(menudata);

    this.modifiedmenus = menudata;
  }
  getTab() {
    console.log(this.modifiedmenus);

    return this.modifiedmenus;
  }

  // added for getting verified with OKTA Password for Affirmation page.
  validateAptaPassword(oktaPassword: string): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Accept', 'application/json');
    const request = {
      password: oktaPassword,
    };
    // tslint:disable-next-line: max-line-length
    return this.httpClient.post(
      this.baseUrlParty + '/me/Verify',
      request,
      { headers: httpHeaders }
    );
  }

  // Delete new registration by passing the transaction Id as a parameter
  deleteNewReg(transactionId: string): Observable<any> {
    return this.httpClient.delete(
      this.baseurl + '/' + transactionId
    );
  }

  enableRegistrationSaveSubmitbutton(reg: RegistrationModel): boolean {
    let enableBtn = false;
    if (reg && reg.registrationStatus.code === RegStatusCode.INPROGRESS) {
      enableBtn = true;
    }
    return enableBtn;
  }

  enableRegForm(type: string, reg: RegistrationModel, selectedApartment: ApartmentInfoModel = null) {
    let enableForm = false;
    const status = reg.registrationStatus.code;
    const incidentTypeCode = reg.registrationType.code;
    // console.log('reg status and reg incident', reg);
    if (type === 'building' && status === RegStatusCode.INPROGRESS &&
      (incidentTypeCode === 'IR' || incidentTypeCode === 'AMD')) {
      enableForm = true;
    } else if (type === 'building' && status === RegStatusCode.INPROGRESS &&
      (incidentTypeCode === 'AO' || incidentTypeCode === 'NRA' ||
        incidentTypeCode === 'RCRS' || incidentTypeCode === 'PVA')) {
      enableForm = false;
    } else if (type === 'buildingService' && status === RegStatusCode.INPROGRESS &&
      (incidentTypeCode === 'IR' || incidentTypeCode === 'AMD')) {
      enableForm = true;
    } else if (type === 'buildingService' && status === RegStatusCode.INPROGRESS &&
      (incidentTypeCode === 'AO' || incidentTypeCode === 'NRA' ||
        incidentTypeCode === 'RCRS' || incidentTypeCode === 'PVA')) {
      enableForm = false;
    } else if (type === 'apartment' && status === RegStatusCode.INPROGRESS &&
      (incidentTypeCode === 'IR' || incidentTypeCode === 'AMD')) {
      enableForm = true;
    } else if (type === 'apartment' && selectedApartment.apartmentId === null && status === RegStatusCode.INPROGRESS
      && (incidentTypeCode === 'NRA' || incidentTypeCode === 'RCRS' || incidentTypeCode === 'PVA')) {
      enableForm = true;
    } else if (type === 'tenant' && (incidentTypeCode === 'IR' || incidentTypeCode === 'AMD') &&
      status === RegStatusCode.INPROGRESS) {
      enableForm = true;
    } else {
      enableForm = false;
      // this.checkSubmitOpt(reg,reg.registrationTypeCode);
    }
    return enableForm;
  }

  setView(type: string) {
    const viewType: ViewType = new ViewType();
    viewType.type = type;
    this.viewSubject.next(type);
  }
}
